import React from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaCalendar, FaUser, FaClock } from 'react-icons/fa';
import "../assets/styles/BlogsData.css";

const blogs = [
  {
    id: 1,
    img: '/assets/aiFeatured.jpg',
    title: 'The Future of AI: Transforming Business Operations in 2025',
    description: 'Discover how artificial intelligence is revolutionizing business processes, from automated customer service to predictive analytics. Learn how companies are leveraging AI to gain competitive advantages and drive innovation.',
    category: 'Artificial Intelligence',
    author: 'Async Vibe Team',
    date: 'March 15, 2025',
    readTime: '5 min read',
    tags: ['AI', 'Machine Learning', 'Business Automation']
  },
  {
    id: 2,
    img: '/assets/flutter.png',
    title: 'Flutter vs React Native: Choosing the Right Cross-Platform Solution',
    description: 'Explore the differences between Flutter and React Native for mobile app development. Understand performance metrics, development speed, and which framework best suits your project requirements.',
    category: 'Mobile Development',
    author: 'Async Vibe Team',
    date: 'March 12, 2025',
    readTime: '7 min read',
    tags: ['Flutter', 'React Native', 'Mobile Apps']
  },
  {
    id: 3,
    img: '/assets/webLanding.png',
    title: 'Full Stack Development: Building Scalable Web Applications',
    description: 'Master the art of full stack development with modern technologies. From frontend frameworks to backend architecture, learn how to build robust, scalable web applications that deliver exceptional user experiences.',
    category: 'Web Development',
    author: 'Async Vibe Team',
    date: 'March 10, 2025',
    readTime: '8 min read',
    tags: ['Full Stack', 'Web Development', 'Scalability']
  }
];

const BlogsData = () => {
  const navigate = useNavigate();

  const handleViewDetails = (blogId) => {
    // Navigate to specific blog details page
    navigate(`/blogs/Details/${blogId}`);
  };

  return (
    <section className="blogs-section">
      <Container>
        {/* Section Header */}
        <div className="blogs-header text-center mb-5">
          <h2 className="blogs-main-title">Latest Insights & Articles</h2>
          <p className="blogs-subtitle">
            Stay updated with the latest trends in technology, development, and business innovation
          </p>
        </div>

        {/* Blog Cards */}
        <Row className="g-4">
          {blogs.map((blog) => (
            <Col key={blog.id} xs={12} md={6} lg={4}>
              <Card className="blog-card h-100">
                {/* Blog Image */}
                <div className="blog-image-container">
                  <Card.Img 
                    variant="top" 
                    src={blog.img} 
                    alt={blog.title}
                    className="blog-image"
                  />
                  <div className="blog-category-badge">
                    <Badge bg="primary">{blog.category}</Badge>
                  </div>
                </div>

                {/* Blog Content */}
                <Card.Body className="blog-content d-flex flex-column">
                  {/* Blog Meta */}
                  <div className="blog-meta mb-3">
                    <div className="meta-item">
                      <FaUser className="meta-icon" />
                      <span>{blog.author}</span>
                    </div>
                    <div className="meta-item">
                      <FaCalendar className="meta-icon" />
                      <span>{blog.date}</span>
                    </div>
                    <div className="meta-item">
                      <FaClock className="meta-icon" />
                      <span>{blog.readTime}</span>
                    </div>
                  </div>

                  {/* Blog Title */}
                  <Card.Title className="blog-title mb-3">
                    {blog.title}
                  </Card.Title>

                  {/* Blog Description */}
                  <Card.Text className="blog-description mb-4">
                    {blog.description}
                  </Card.Text>

                  {/* Blog Tags */}
                  <div className="blog-tags mb-3">
                    {blog.tags.map((tag, index) => (
                      <Badge 
                        key={index} 
                        bg="light" 
                        text="dark" 
                        className="blog-tag me-2"
                      >
                        {tag}
                      </Badge>
                    ))}
                  </div>

                  {/* View Details Button */}
                  <div className="mt-auto">
                    <button 
                      className="blog-view-details-btn" 
                      onClick={() => handleViewDetails(blog.id)}
                    >
                      View Details →
                    </button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default BlogsData;
  
